import React from "react";
import CommonSelectsQuestionEdit from "./CommonSelectsQuestionEdit";

function QuestionMultipleOpenEdit(props) {
    return (<CommonSelectsQuestionEdit {...props}/>);
}

export default QuestionMultipleOpenEdit;